import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

interface IncludeSimulatedSwitchProps {
  id: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

/** Platform lists hide simulation-marked rows unless this is on. */
export function IncludeSimulatedSwitch({ id, checked, onCheckedChange }: IncludeSimulatedSwitchProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
      <Label htmlFor={id} className="text-sm font-normal text-muted-foreground">
        Include simulated
      </Label>
    </div>
  )
}
